import React from 'react';

function Solutions() {
  return (
    <>
      {/* ░░ SOLUTIONS HEADER ░░ */}
<section className="section section-light" style={{paddingBottom: '40px'}} id="solutions">
  <div className="section-inner animate-on-scroll">
    <div className="section-eyebrow">Our Key Solutions</div>
    <h2 className="section-h2">The infrastructure behind<br /><em>every rupee you move.</em></h2>
    <p className="section-lead">Four production-ready pillars — routing, security, analytics, and scale — deployed and audited to enterprise grade.</p>
  </div>
</section>

{/* SOL 1 */}
<div className="sol-block" id="sol1">
  <div className="sol-text" style={{background: 'var(--cyan-l)'}}>
    <div className="sol-num">01</div>
    <span className="sol-tag" style={{background: 'rgba(0,153,214,.15)', color: 'var(--cyan)'}}>Smart Routing</span>
    <h3 className="sol-h3">Efficient Routing for Transaction Success.</h3>
    <p className="sol-p">Intelligent UPI switching ensures seamless routing, minimizing failures and optimizing speed for a smooth transaction experience across all your payment channels.</p>
    <a className="sol-link btn-shimmer" href="#">Explore solutions →</a>
  </div>
  <div className="sol-visual" style={{background: '#D8F0FA', position: 'relative'}}>
    <div className="canvas-wrap"><canvas id="routeCanvas" style={{position: 'absolute', inset: 0, width: '100%', height: '100%'}}></canvas><div className="canvas-skeleton" id="sk1"><div className="skel-bar"></div><div className="skel-bar"></div><div className="skel-bar"></div></div></div>
  </div>
</div>

<div className="brand-divider"><div className="bd-line"></div><div className="bd-dot"></div><div className="bd-dot"></div><div className="bd-dot"></div><div className="bd-line"></div></div>

{/* SOL 2 */}
<div className="sol-block flip" id="sol2">
  <div className="sol-text" style={{background: 'linear-gradient(145deg,#0A1640,#1A2B6B)'}}>
    <div className="sol-num" style={{color: 'rgba(0,153,214,.1)'}}>02</div>
    <span className="sol-tag" style={{background: 'rgba(0,153,214,.18)', color: 'var(--cyan)'}}>AI Security</span>
    <h3 className="sol-h3" style={{color: '#fff'}}>Enhanced Security and Fraud Protection.</h3>
    <p className="sol-p" style={{color: 'rgba(255,255,255,.55)'}}>Safeguard transactions with AI-driven fraud detection, real-time alerts, and advanced risk management tools for comprehensive protection at every step.</p>
    <a className="sol-link btn-shimmer" style={{color: 'var(--cyan)', borderColor: 'var(--cyan)'}} href="#">Learn about security →</a>
  </div>
  <div className="sol-visual" style={{background: '#0A1230', position: 'relative'}}>
    <div className="canvas-wrap"><canvas id="fraudCanvas" style={{position: 'absolute', inset: 0, width: '100%', height: '100%'}}></canvas><div className="canvas-skeleton" id="sk2"><div className="skel-bar"></div><div className="skel-bar"></div><div className="skel-bar"></div></div></div>
  </div>
</div>

<div className="brand-divider"><div className="bd-line"></div><div className="bd-dot"></div><div className="bd-dot"></div><div className="bd-dot"></div><div className="bd-line"></div></div>

{/* SOL 3 */}
<div className="sol-block" id="sol3">
  <div className="sol-text" style={{background: '#F0FBF6'}}>
    <div className="sol-num" style={{color: 'rgba(62,188,121,.08)'}}>03</div>
    <span className="sol-tag" style={{background: 'rgba(62,188,121,.15)', color: 'var(--green-d)'}}>Analytics</span>
    <h3 className="sol-h3">Real-Time Performance Insights.</h3>
    <p className="sol-p">Monitor and analyze transactions with real-time dashboards, detailed reports, and actionable insights to optimize your business performance continuously.</p>
    <a className="sol-link btn-shimmer" style={{color: 'var(--green-d)', borderColor: 'var(--green-d)'}} href="#">View analytics →</a>
  </div>
  <div className="sol-visual" style={{background: '#D9F5E9', position: 'relative'}}>
    <div className="canvas-wrap"><canvas id="chartCanvas" style={{position: 'absolute', inset: 0, width: '100%', height: '100%'}}></canvas><div className="canvas-skeleton" id="sk3"><div className="skel-bar"></div><div className="skel-bar"></div><div className="skel-bar"></div></div></div>
  </div>
</div>

<div className="brand-divider"><div className="bd-line"></div><div className="bd-dot"></div><div className="bd-dot"></div><div className="bd-dot"></div><div className="bd-line"></div></div>

{/* SOL 4 */}
<div className="sol-block flip" id="sol4">
  <div className="sol-text" style={{background: 'var(--off)'}}>
    <div className="sol-num" style={{color: 'rgba(26,43,107,.06)'}}>04</div>
    <span className="sol-tag" style={{background: 'rgba(26,43,107,.08)', color: 'var(--navy)'}}>Scale</span>
    <h3 className="sol-h3">Scalable Infrastructure for Growing Demands.</h3>
    <p className="sol-p">Use real-time dashboards and detailed reports to track transactions, gain actionable insights, and enhance business operations — whether you process hundreds or millions.</p>
    <a className="sol-link btn-shimmer" style={{color: 'var(--navy)', borderColor: 'var(--navy)'}} href="#">See infrastructure →</a>
  </div>
  <div className="sol-visual" style={{background: '#E8EEF8', position: 'relative'}}>
    <div className="canvas-wrap"><canvas id="scaleCanvas" style={{position: 'absolute', inset: 0, width: '100%', height: '100%'}}></canvas><div className="canvas-skeleton" id="sk4"><div className="skel-bar"></div><div className="skel-bar"></div><div className="skel-bar"></div></div></div>
  </div>
</div>

{/* HOW IT WORKS */}
<section className="hiw-section" id="hiw">
  <div className="hiw-inner">
    <div className="animate-on-scroll">
      <div className="section-eyebrow hiw-eyebrow">How It Works</div>
      <h2 className="section-h2 hiw-h2">Live in 48 hours.<br />Protected forever.</h2>
      <p className="section-lead hiw-lead">No 6-week onBoarding. No professional services fees. Connect, configure, go live.</p>
    </div>
    <div className="hiw-steps">
      <div className="hiw-step" style={{transitionDelay: '.05s'}}>
        <div className="hiw-step-n">01</div><div className="hiw-step-icon-wrap"><svg className="sv-icon" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" ><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg></div>
        <div className="hiw-step-title">Enable Fraud Detection</div>
        <p className="hiw-step-body">Use our built-in tools to monitor and detect fraudulent activities in real time — the moment a suspicious pattern emerges, we act instantly.</p>
      </div>
      <div className="hiw-step" style={{transitionDelay: '.13s'}}>
        <div className="hiw-step-n">02</div><div className="hiw-step-icon-wrap"><svg className="sv-icon" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" ><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg></div>
        <div className="hiw-step-title">Set Risk Parameters</div>
        <p className="hiw-step-body">Customize risk thresholds to align with your business needs. Define velocity limits, geo-fences, and amount caps — no code required.</p>
      </div>
      <div className="hiw-step" style={{transitionDelay: '.22s'}}>
        <div className="hiw-step-n">03</div><div className="hiw-step-icon-wrap"><svg className="sv-icon" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" ><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg></div>
        <div className="hiw-step-title">Receive Alerts</div>
        <p className="hiw-step-body">Get instant notifications for high-risk or flagged transactions via webhook, SMS, or dashboard. Your team responds in seconds.</p>
      </div>
    </div>
  </div>
</section>
    </>
  );
}

export default Solutions;
